import ClientsTable from "../components/ClientsTable";
import { deleteLogicClient, getClients } from "../api/clientsAPI";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { setCurrentPage, setSearchText } from "../../../../redux/historicalSlice";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import AlertMessage from "../../../../components/AlertMessage";
import Search from "../../../../components/Search";
import { ClientListFields, ClientsActions } from "../types";
import { useAlert } from "../../../../hooks/useAlert";
import { Pagination } from "../../../../types/Pagination";
import { DeleteReasonDto } from "../../../../types/DeleteReasonDto";
import { ApiErrorResponse } from "../../../../types/ApiErrorResponse";
import { useUserPermissions } from "../../../../utils/auth";
import { PERMISSIONS } from "../../../../constants/permissions";

export default function ClientsList() {
    const { t } = useTranslation('client');
    const permissions = useUserPermissions();

    //actions
    const clientsActions: ClientsActions = {
        onDelete: (id: number, body: DeleteReasonDto) => deleteLogicClient(id, body),
        onView: (id: number) => navigate(`/admin/client/edit/${id}`),
    }

    //ReactRedux Toolkit - dispatch 
    const dispatch = useDispatch();
    const currentPage = useSelector((state: RootState) => state.historical.clients.currentPage);
    const itemsPerPage = useSelector((state: RootState) => state.historical.clients.itemsPerPage);
    const searchText = useSelector((state: RootState) => state.historical.clients.searchText);

    const [searchTerm, setSearchTerm] = useState('');

    const [clientsData, setClientsData] = useState<Pagination<ClientListFields>>({
        page: 0,
        size: 0,
        totalPages: 0,
        totalRecords:0,
        items: []
    });

    const [messageError, setMessageError] = useState<string | undefined>('');

    const fetchClients = async (page = currentPage, search = searchTerm) => {
        getClients(page, itemsPerPage, search).then(data => {
            setClientsData(data);
        }).catch((err: ApiErrorResponse) => {
            setMessageError(err.message);
        });
    };

    //actualiza datos paginacion, busqueda
    useEffect(() => {
        fetchClients();
    }, [currentPage, itemsPerPage, searchTerm]);

    const navigate = useNavigate();

    const handleSearchInput = () => {
        setSearchTerm(searchText || '');
        dispatch(setCurrentPage({ table: "clients", page: 1 }));
    };

    const handleClear = () => {
        dispatch(setCurrentPage({ table: "clients", page: 1 }));
        dispatch(setSearchText({ table: "clients", text: '' }));
        setSearchTerm("");
    }

    //alerta mensaje
    const { alert, hideAlert, isVisible } = useAlert({ fromLocation: true });

    return (
        <>
            <Row className="mb-2 align-items-center justify-content-between">
                <Col xs={12} md>
                    <h2>{t("client:titleClient")}</h2>
                </Col>
                {permissions.length > 0 && permissions.includes(PERMISSIONS.CLIENT_MANAGEMENT.CREATE) && (
                    <Col xs={12} md="auto" className="d-flex align-items-center justify-content-end mt-2 mt-md-0">
                        <Button
                            variant="primary"
                            style={{ whiteSpace: "nowrap" }}
                            onClick={() => navigate(`/admin/client/new-client`)}>
                            {t("client:buttonNewClient")}
                        </Button>
                    </Col>
                )}
            </Row>
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {isVisible && (
                        <AlertMessage
                            message={alert!.message}
                            type={alert!.type}
                            onClose={hideAlert}
                        />
                    )}
                </Col>
                <Col className="text-center" xs={12} md={12}>
                    {messageError && <div className="alert alert-danger">{messageError}
                        <button
                            type="button"
                            className="btn-close btn-sm position-absolute top-0 end-0 m-2"
                            aria-label="Close"
                            onClick={() => setMessageError(undefined)}
                        ></button>
                    </div>}
                </Col>
            </Row>

            <Row className="mb-2">
                <Col xs={12}>
                    <Search
                        searchText={searchText || ''}
                        onChange={(text) => dispatch(setSearchText({ table: "clients", text: text }))}
                        onSearch={handleSearchInput}
                        onClear={handleClear}
                    />
                </Col>
            </Row>

            <ClientsTable
                clientsData={clientsData}
                currentPage={currentPage}
                pageSize={itemsPerPage}
                totalPages={clientsData.totalPages}
                clientsActions={clientsActions}
            />
        </>
    );
}


